import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import _ from 'lodash'

import { Paper } from '@material-ui/core'
import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core/styles'

const styles = (theme: Theme) => createStyles({
  root: {
    margin: theme.spacing.unit * 3,
    maxHeight: '93%',
    overflowX: 'auto',
  },
})

interface IThemeProps extends WithStyles<typeof styles> {
  theme: Theme
}

type IAllProps = IThemeProps

// tslint:disable-next-line
class About extends React.Component<IAllProps> {

  public render() {
    const { classes } = this.props
    const buildTimestamp: number = Number(process.env.REACT_APP_BUILD_DATE) || moment().unix()
    const buildDate = moment.unix(buildTimestamp).format('MMM do HH:mm:ss')

    return (
      <Paper className={classes.root}>
        <h1>Build Hash</h1>
        <p>{process.env.REACT_APP_COMMIT_HASH || "<Development>"}</p>
        <h1>Build Date</h1>
        <p>{buildDate}</p>
      </Paper>
    )
  }
}

export default connect()(withStyles(styles, { withTheme: true })(About))



// WEBPACK FOOTER //
// ./src/About.tsx